<template>
  <div>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <search-button 
                    v-model="searchText"
                    id="searchText"
                    label=""
                    placeholder="メーカ名、品番等の一部"
                    button-name="検索"
                    class="str15em align_left"
                    @click="searchData"
                />
            </div>
            <div class="modal-body">
                <div>
                    <h4>検索結果</h4>
                    <p
                        class="p_block"
                        v-if="length == 0"
                    >
                        条件に一致する機器がありません。
                    </p>
                    <p
                        class="p_block"
                        v-if="length >= 20"
                    >
                        検索結果をすべて表示しきれません。条件を追加してください。
                    </p>
                </div>
                <app-radio
                    v-for="data in resultData"
                    :key="data.index"
                    :label="data.index"
                    unit=""
                    v-model="selectedData"
                    :value="data.value.toString()"
                    class="button_table"
                >
                    <table>
                        <tr>
                            <th>ブランド事業者名</th>
                            <td>{{ data.brandCompanyName }}</td>
                        </tr>
                        <tr v-if="data.systemNumber != undefined">
                            <th>システム形式</th>
                            <td>{{ data.systemNumber }}</td>
                        </tr>
                        <tr v-if="data.heatPumpUnitNumber != undefined">
                            <th>ヒートポンプユニット番号</th>
                            <td>{{ data.heatPumpUnitNumber }}</td>
                        </tr>
                        <tr v-if="data.powerUnitNumber != undefined">
                            <th>{{powerUnitNumberName()}}</th>
                            <td>{{ data.powerUnitNumber }}</td>
                        </tr>
                        <tr>
                            <th>{{tankUnitNumberName()}}</th>
                            <td>{{ data.tankUnitNumber }}</td>
                        </tr>
                        <tr v-if="data.backupBoilerNumber != undefined">
                            <th>補助熱源機品番</th>
                            <td>{{ data.backupBoilerNumber }}</td>
                        </tr>
                        <tr>
                            <th>成績証明書番号または自己適合宣言書番号</th>
                            <td>{{ data.certificationNumber }}</td>
                        </tr>
                    </table>
                </app-radio>
            </div>
            <div class="modal-footer">
                <app-button
                    @button-click="hideSearchResult"
                    value="キャンセル"
                    this-class="btn_cancel"
                />
                <app-button
                    @button-click="commitSearchResult"
                    value="確定"
                    :disabled="selectedData == ''"
                    this-class=""
                />
            </div>
        </div>
    </div>
  </div>
</template>


<script>
/**
 * 検索結果の表示モーダル
 * 
 * [算出プロパティ]
 * type ... 検索対象のタイプ(PEFC,SOFC,給湯専用型電気ヒートポンプ・ガス瞬間式併用型給湯機、給湯・温水暖房一体型電気ヒートポンプ・ガス瞬間式併用型給湯機)
 * value ... 検索ワード
 * searchResultIsOpen ... 本コンポーネントの表示制御
 * resultData ... 検索結果データ
 * length ... 検索結果の配列長
 * 
 * [イベント処理]
 * searchSetResult ... 受け取った検索結果をStoreに保存
 * searchSetSelected ... 受け取った選択結果をStoreに保存
 * dataUpdate ... 選択結果でStoreの送信用データを更新
 * viewSearchResultHide ... 本コンポーネントを閉じる
 * 検索ワード入力時 ... this.value = value
 * 検索実行時 ... typeに応じた検索を実行する
 * 検索完了時 ... searchSetResult({value:this.value, result:data, type:this.type})
 * キャンセルボタン押下時 ... キャンセル処理実行
 * 確定ボタン押下時 ... 選択結果を保存
 * <modal-search-result v-if="searchResultIsShow" />
 * 
 * [データ]
 * selectedData ... 選択済み機器の一時記録用
 */
import device from '@/mixins/device'
import { mapGetters, mapActions } from 'vuex'

export default {
    name:"ModalSearchResult",
    data(){
        return{
            searchText: "",
            selectedData: "",
        }
    },
    mixins:[device],
    computed:{
        ...mapGetters({
            /**
             * 検索対象のタイプ(PEFC,SOFC,給湯専用型電気ヒートポンプ・ガス瞬間式併用型給湯機、給湯・温水暖房一体型電気ヒートポンプ・ガス瞬間式併用型給湯機)
             */
            type:'search/getType',
            /**
             * 検索ワード
             */
            value:'search/getValue',
            /**
             * 本コンポーネントの表示制御
             */
            searchResultIsOpen:'view/getSearchResultState',
            /**
             * 検索結果データ
             */
            resultData:'search/getResult',
        }),
        /**
         * 検索結果の配列長
         */
        length(){
            return this.resultData.length
        }
    },
    mounted: function(){
        this.updateSearchText(this.value)
    },
    methods: {
        ...mapActions({
            /**
             * 受け取った検索結果をStoreに保存
             */
            searchSetResult:'search/setResult',
            /**
             * 受け取った選択結果をStoreに保存
             */
            searchSetSelected:'search/setSelected',
            /**
             * 選択結果でStoreの送信用データを更新
             */
            dataUpdate:'data/update',
            /**
             * 本コンポーネントを閉じる
             */
            viewSearchResultHide:'view/searchResultHide',
        }),
        /**
         * 検索ワードを更新
         */
        updateSearchText(value){
            this.searchText = value
        },
        /**
         * typeに応じた検索を実行する(PEFCかSOFCならコジェネ検索、それ以外なら給湯機器検索)
         */
        searchData(){
            if (this.type == 'PEFC' || this.type == 'SOFC') {
                this.searchCogen(this.type, this.searchText)
                    .then(data => {
                        this.afterSearch(data)
                    })
            } else if (this.type == 'hw_senyo' || this.type == 'hw_ittai') {
                this.searchHybridWaterHeater(this.searchText)
                    .then(data => {
                        this.afterSearch(data)
                    })
            } else {
                this.searchElectricHeatPump(this.searchText)
                    .then(data => {
                        this.afterSearch(data)
                    })
            }
        },
        /**
         * 検索完了時にsearchSetResultを実行する
         */
        afterSearch(data){
            this.searchSetResult({value:this.searchText, result:data, type:this.type})
        },
        /**
         * キャンセル時の処理を実行
         */ 
        hideSearchResult(){
            if (this.type == 'PEFC') {
                this.dataUpdate({cogen_pefc_package_filter:this.value})
            } else if (this.type == 'SOFC') {
                this.dataUpdate({cogen_sofc_package_filter:this.value})
            } else if (this.type == 'hw_ittai') {
                this.dataUpdate({hybridwaterheater_ittai_filter:this.value})
            } else if (this.type == 'hw_senyo') {
                this.dataUpdate({hybridwaterheater_senyo_filter:this.value})
            } else {
                this.dataUpdate({electricHeatPumpFilter:this.value})
            }
            this.viewSearchResultHide()
        },
        /**
         * 選択結果を保存
         */ 
        commitSearchResult(){
            if (this.type == 'PEFC') {
                this.searchSetSelected({value:this.selectedData, type:'pefc'})
                this.dataUpdate({cogen_pefc_package_id:this.selectedData})
            } else if (this.type == 'SOFC') {
                this.searchSetSelected({value:this.selectedData, type:'sofc'})
                this.dataUpdate({cogen_sofc_package_id:this.selectedData})
            } else if (this.type == 'hw_ittai') {
                this.searchSetSelected({value:this.selectedData, type:this.type})
                this.dataUpdate({hw_ittai_sr18_package_id:this.selectedData})                
            } else if (this.type == 'hw_senyo') {
                this.searchSetSelected({value:this.selectedData, type:this.type})
                this.dataUpdate({hw_senyo_sr7_package_id:this.selectedData})                
            } else {
                this.searchSetSelected({value:this.selectedData, type:this.type})
                this.dataUpdate({hw_senyo_sr6_package_id:this.selectedData})                
            }
            this.hideSearchResult()
        },
        powerUnitNumberName(){
            return this.type == 'electricHeatPump' ? 'ヒートポンプユニット形式' : '発電ユニット番号'
        },
        tankUnitNumberName(){
            return this.type == 'electricHeatPump' ? '貯湯ユニット形式' : '貯湯ユニット品番'
        }
    },
}
</script>

<style scoped>
div.modal-dialog{
    display: block;
    width: 100%;
    height: 100%;
    min-height: 80vh;
    padding: 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    overflow-y:auto;
    -ms-overflow-style:none;
    top: 0;
    z-index: 9999;
}
_:-ms-lang(x)::-ms-backdrop, div.modal-dialog {
    overflow: hidden;
}
.modal-content{
    display: block;
    width: 75%;
    max-height: 90vh;
    min-height: calc(40vh + 200px);
    margin:  2vh auto;
    padding: 1em 4em;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 5px 15px 2px rgba(0, 0, 0, 0.5);
}
.modal-header{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 2px solid #ccc;
    padding: 8px 0;
}
.modal-header >>> .search_form{
    margin: 0 16px;
}
.modal-header >>> .btn_search{
    height: 26px;
    margin: 2px 0 2px -2px;
    padding: 0 16px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.p_block{
    display:block;
    width:100%;
    margin: 8px 0;
    padding: 2px 0;
    line-height: 1em;
}
.modal-body{
    display: block;
    height: auto;
    min-height: 50vh;
    max-height: calc(90vh - 150px);
    margin-bottom: 16px;
    font-size: 12px;
    line-height: 24px;
    overflow-y: auto;
}
.modal-footer{
    display: flex;
    justify-content: center;
    min-height: 60px;
}

/* ボタンテーブルで選択させる */
.button_table{
    display: inline-block;
    box-sizing: border-box;
    width: calc(50% - 32px);
    margin: 8px;
    position: relative;
}
.button_table >>> label{
    width: 100%;
    padding: 16px 8px 16px 32px;
    color: #777;
    border: #ccc solid 2px;
}
.button_table >>> label.checked{
    color: black;
    background-color:rgb(255, 254, 218);
    border-color: #41B8D4;
}

.button_table >>> label:before{
    top: 0.537em;
    left: 0.56em;
}
.button_table >>> label:after{
    top: 0.5em;
    left: 0.5em;
}
.button_table >>> label:hover{
    border: #777 solid 2px;
}

.button_table th{
    font-size: 12px;
    font-weight: 500;
    padding-right: 16px;
}
.button_table td{
    font-size: 16px;
    font-weight: bolder;
}

/* レスポンシブ（タブレット縦よりウインドウ幅が狭いもの） */
@media screen and (max-width: 800px) {
    .modal-content{
        max-width: 80vw;
        max-height: 100%;
        padding: 1em 2em;
    }
    .modal-footer{
        flex-direction: column;
    }
    .button_table{
        width: 95%;
        margin: 8px auto;
    }
}

/* レスポンシブ（1400pxよりウインドウ幅が狭いもの） */
@media screen and (max-width: 1400px) {
    .button_table table tr{
        display:flex;
        flex-direction: column;
        margin-bottom: 4px;
    }
}
</style>


